/*
 * @Description: map结构组装树形结构
 * @Author: guqiang
 * @Date: 2021-09-09 14:29:17
 * @LastEditors: guqiang
 * @LastEditTime: 2021-09-09 18:39:50
 */

/**
 * @description: 
 * @param {*} list
 * @param {*} id
 * @param {*} parentId
 * @return {*} treeNode
 */
export default function(list = [], id, parentId) {
    const data = JSON.parse(JSON.stringify(list)); // 浅拷贝不改变源数据
    const treeNode = [];
    if (!Array.isArray(data)) {
        return treeNode;
    }
    data.forEach(item => {
        delete item.children;
    });
    const map = {};
    data.forEach(item => {
        map[item[id]] = item;
    });
    data.forEach(item => {
        let parent = null;
        if (item.parentId) {
            parent = map[item[parentId]];
        }
        if (parent) {
            (parent.children || (parent.children = [])).push(item);
        } else {
            treeNode.push(item);
        }
    });
    return treeNode;
}


